import React from 'react';
import { motion } from 'framer-motion';
export function SolutionIntro() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-522">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-523">
        <h2 className="text-amber-500 font-bold tracking-widest uppercase mb-4 text-sm md:text-base" data-id="element-524">
          La Solución
        </h2>
        <h3 className="text-4xl md:text-5xl font-extrabold text-white mb-8 leading-tight" data-id="element-525">
          Presentamos el <br className="hidden md:block" data-id="element-526" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-emerald-600" data-id="element-527">
            MEGA PACK GESTIÓN ORGANIZACIONAL
          </span>
        </h3>

        <div className="space-y-6 text-lg md:text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto mb-16" data-id="element-528">
          <p data-id="element-529">
            El sistema más completo en español para transformar una empresa
            caótica y dependiente del dueño en una organización estructurada,
            eficiente y escalable.
          </p>
          <p data-id="element-530">
            Desarrollado con los mismos marcos teóricos y herramientas prácticas
            que se enseñan en las mejores escuelas de negocios del mundo, pero
            traducido al lenguaje y la realidad de las PyMEs latinoamericanas.
          </p>
          <p className="text-white font-bold text-xl md:text-2xl p-6 bg-emerald-900/20 border border-emerald-500/30 rounded-xl" data-id="element-531">
            Sin teoría vacía. Sin conceptos que suenan bien pero no se pueden
            aplicar. Todo listo para implementar desde el primer día.
          </p>
        </div>

        <div className="inline-block relative" data-id="element-532">
          <div className="absolute inset-0 bg-amber-500/20 blur-xl rounded-full" data-id="element-533" />
          <h4 className="relative text-2xl md:text-3xl font-bold text-white border-b-2 border-amber-500 pb-2" data-id="element-534">
            ELEGÍ EL NIVEL QUE SE ADAPTA A TU MOMENTO
          </h4>
        </div>
      </motion.div>
    </section>;
}